import { useCallback, useEffect, useState } from 'react';
import {
  DEFAULT_CUSTOM_CATEGORY_LABEL,
  getCustomCategoryLabel,
  setCustomCategoryLabel,
} from '../firebase/usersService';

// Nome dell'etichetta "Personalizzata" per un dato account (uid del
// proprietario dei dati: la strategia o l'asta che si sta guardando, non
// necessariamente l'utente loggato — vedi StrategyEditPage.js `effectiveUid`).
export default function useCustomCategoryLabel(uid) {
  const [label, setLabel] = useState(DEFAULT_CUSTOM_CATEGORY_LABEL);

  useEffect(() => {
    if (!uid) { setLabel(DEFAULT_CUSTOM_CATEGORY_LABEL); return; }
    let cancelled = false;
    getCustomCategoryLabel(uid).then((value) => { if (!cancelled) setLabel(value); });
    return () => { cancelled = true; };
  }, [uid]);

  const rename = useCallback(async (next) => {
    const normalized = String(next || '').trim();
    if (!uid || !normalized) return false;
    setLabel(normalized);
    await setCustomCategoryLabel(uid, normalized);
    return true;
  }, [uid]);

  return [label, rename];
}
